import WithAccordion from '../../customComponents/CustomAccordion';
import { GapOptions, JustifyOptions } from '../../../utils/constants';
import { Select } from '../../form-fields/Select';
import ToggleGroup from '../../../../components/common/toggleButtonGroupComponent';
import ColorPicker from '../../../puck/reusable-props/ColorPicker';
import { FieldLabel } from '@measured/puck';
import CustomTooltip from '../../../../components/common/tooltip';

type DeviceType = 'mobile' | 'tablet' | 'desktop';
const options = [
  { value: 'yes', label: 'Yes', divider: 'yes' },
  { value: 'no', label: 'No', divider: 'no' },
];

export interface FooterFieldsProps {
  currentDevice: DeviceType;
  mobile: {
    gap: string;
    justifyContent: string;
    divider: string;
    dividerColor: string;
  };
  tablet: {
    gap: string;
    justifyContent: string;
    divider: string;
    dividerColor: string;
  };
  desktop: {
    gap: string;
    justifyContent: string;
    divider: string;
    dividerColor: string;
  };
}

interface IProps {
  value: FooterFieldsProps;
  onChange: (_value: FooterFieldsProps) => void;
}

const FooterFields = ({ value, onChange }: IProps) => {
  const structuredCloneObj = { ...structuredClone(value) };

  return (
    <WithAccordion title="Customize Footer">
      <ToggleGroup
        label="Device"
        value={value?.currentDevice}
        onChange={newValue => {
          onChange({
            ...structuredClone(value),
            currentDevice: newValue as DeviceType,
          });
        }}
        options={[
          { label: 'Desktop', value: 'desktop' },
          { label: 'Tablet', value: 'tablet' },
          { label: 'Mobile', value: 'mobile' },
        ]}
      />
      <FieldLabel
        label={
          (
            <CustomTooltip title="Gap">
              <span>Gap</span>
            </CustomTooltip>
          ) as React.ReactNode as string
        }>
        <Select
          value={value?.[value?.currentDevice]?.gap}
          className="pagebuilder-theme"
          options={GapOptions}
          onChange={e => {
            onChange({
              ...structuredCloneObj,
              [value?.currentDevice]: {
                ...structuredCloneObj[value?.currentDevice],
                gap: e.target.value,
              },
            });
          }}
        />
      </FieldLabel>

      <FieldLabel
        label={
          (
            <CustomTooltip title="Justify Content">
              <span>Justify Content</span>
            </CustomTooltip>
          ) as React.ReactNode as string
        }>
        <Select
          className="pagebuilder-theme"
          value={value?.[value?.currentDevice]?.justifyContent || ''}
          onChange={e =>
            onChange({
              ...structuredCloneObj,
              [value?.currentDevice]: {
                ...structuredCloneObj?.[value?.currentDevice],
                justifyContent: e.target.value,
              },
            })
          }
          options={JustifyOptions}
        />
      </FieldLabel>
      <ToggleGroup
        value={value?.[value?.currentDevice]?.divider}
        label="Divider"
        onChange={val => {
          onChange({
            ...structuredCloneObj,
            [value.currentDevice]: {
              ...structuredCloneObj[value.currentDevice],
              divider: val,
            },
          });
        }}
        options={options}
      />
      <ColorPicker
        value={value?.[value?.currentDevice]?.dividerColor}
        onChange={val => {
          onChange({
            ...structuredCloneObj,
            [value.currentDevice]: {
              ...structuredCloneObj[value.currentDevice],
              dividerColor: val,
            },
          });
        }}
        label="Divider Color"
        tooltip="Color"
      />
    </WithAccordion>
  );
};

export default FooterFields;
